module.exports = __webpack_public_path__ + "static/img/icon.team.d3af003.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon.team.png
// module id = 1266
// module chunks = 382